import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface PaginationProps {
  page: number;
  setPage: (page: number) => void;
  count: number;
  limit?: number;
  loading: boolean;
  isRefetching?: boolean;
}

const Pagination: FC<PaginationProps> = ({ page, setPage, count, limit = 5, loading, isRefetching }) => {
  const totalPages = Math.ceil(count / limit);
  const { t } = useTranslation();

  const nextPage = () => {
    if (page < totalPages && !loading) {
      setPage(page + 1);
    }
  };

  const prevPage = () => {
    if (page > 1 && !loading) {
      setPage(page - 1);
    }
  };

  return (
    <nav>
      <ul className="pagination justify-content-end">
        <li className="page-item text-center">
          <button
            id="prev_button"
            onClick={prevPage}
            className={`page-link ${page === 1 || isRefetching ? 'disabled' : ''}`}
            disabled={page === 1 || isRefetching}
            style={{ width: '120px' }}
          >
            <i className="mdi mdi-chevron-left" />
            {t('Pagination.prev')}
          </button>
        </li>
        <li className="page-item paginate_button active">
          <button className="page-link" disabled={isRefetching}>
            <span id="page_number">
              {page}/{totalPages}
            </span>
          </button>
        </li>
        <li className="page-item text-center">
          <button
            onClick={nextPage}
            id="next_button"
            className={`page-link ${page === totalPages || isRefetching ? 'disabled' : ''}`}
            disabled={page === totalPages || isRefetching}
            style={{ width: '120px' }}
          >
            {t('Pagination.next')}
            <i className="mdi mdi-chevron-right" />
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
